import React from "react";
import "./MovingServices.css";

const services = [
  {
    title: "Home Loan",
    img: "https://cdn-icons-png.flaticon.com/512/3135/3135706.png",
  },
  {
    title: "Home Interior Design",
    img: "https://cdn-icons-png.flaticon.com/512/1046/1046876.png",
  },
  {
    title: "Valuation",
    img: "https://cdn-icons-png.flaticon.com/512/2331/2331941.png",
  },
  {
    title: "Vastu Calculator",
    img: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
  },
  {
    title: "Property Management",
    img: "https://cdn-icons-png.flaticon.com/512/619/619153.png",
  },
  {
    title: "Sell or Rent Property",
    img: "https://cdn-icons-png.flaticon.com/512/1086/1086741.png",
  },
];

function MovingServices() {
  return (
    <section className="moving-services">
      <p className="section-tag">OUR SERVICES</p>
      <h2 className="section-heading">What We Offer</h2>
      <div className="gold-line"></div>

      <div className="scroll-wrapper">
        <div className="scroll-track">
          {[...services, ...services].map((item, index) => (
            <div className="service-item" key={index}>
              <div className="icon-box">
                <img src={item.img} alt={item.title} />
              </div>
              <p>{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MovingServices;
